export const call = {
  status: {
    answered: 'Terjawab',
    busy: 'Sibuk',
    no_answer: 'Tidak terjawab',
    failed: 'Gagal',
    active: 'Aktiv',
    error: 'Gagal',
    processing: 'Proses'
  },

  type: {
    outgoing: 'Keluar',
    incoming: 'Masuk'
  }
};
